module.exports = __webpack_public_path__ + "k.no1.2ce06e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/k.no1.jpg
// module id = X36I
// module chunks = 0